import type React from "react"

import { Header, Icon } from "semantic-ui-react"

type IconHeaderProps = {
  as?: string
  icon: string
  header: string
  content: string | React.ReactNode
  wrapped?: boolean
}

export const IconHeader = ({ as, icon, header, content, wrapped }: IconHeaderProps) => {
  if (wrapped) {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: 5,
            marginTop: 5,
          }}
        >
          <Icon name={icon} style={{ fontSize: 40, height: "0.8em", color: "rgb(75, 92, 107)" }} />
          <Header as={as} style={{ margin: "0 0 5px 0" }}>
            {header}
          </Header>
        </div>
        <div>{content}</div>
      </div>
    )
  }
  return (
    <div style={{ display: "flex", flex: "auto" }}>
      <div style={{ textAlign: "center" }}>
        <Icon name={icon} style={{ fontSize: 40, color: "rgb(75, 92, 107)" }} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", paddingLeft: 10 }}>
        <Header as={as} style={{ marginBottom: 5 }}>
          {header}
        </Header>
        <div>{content}</div>
      </div>

      <div style={{ clear: "both" }} />
    </div>
  )
}
